export const numberFormat = int => {
  return new Intl.NumberFormat().format(int);
};

export const ctrFormat = ctr => {
  return ctr < 0.001 ? '< %0.001' : `% ${ctr.toFixed(3)}`;
};

export const averagePercentFormat = percent => {
  return percent < 0.001 ? '0' : `$ ${parseFloat(percent).toFixed(2)}`;
};
